export const TERM_10_YEARS = "10Y"
export const TERM_15_YEARS = "15Y"
export const TERM_20_YEARS = "20Y"
export const TERM_30_YEARS = "30Y"
export const TERM_100UL = "100UL"
export const TERM_105_UL = "105UL"
export const TERM_LIFETIME = "120UL"

export const TERM_CHOICES = {
    [TERM_10_YEARS]: "10 Year Term",
    [TERM_15_YEARS]: "15 Year Term",
    [TERM_20_YEARS]: "20 Year Term",
    [TERM_30_YEARS]: "30 Year Term",
    [TERM_100UL]: "Age 100+",
}

export const TERM_VALUES = Object.keys(TERM_CHOICES);
